/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Speakers_Metrics_Filename_LabelInputs */



/**
* | output |
* | --- |
* | "Filename" |
*
* @param {Speakers_Metrics_Filename_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const speakers_metrics_filename_label = /** @type {((inputs?: Speakers_Metrics_Filename_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Speakers_Metrics_Filename_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Filename")
	if (locale === "de") return /** @type {LocalizedString} */ ("Filename")
	if (locale === "it") return /** @type {LocalizedString} */ ("Filename")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Filename")
	if (locale === "es") return /** @type {LocalizedString} */ ("Filename")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Filename")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Filename")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Filename")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Filename")
	return /** @type {LocalizedString} */ ("Filename")
});